import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ClubProfileProgressRequest } from '@/shared/api/requests/profile-progress/club/request';
import { clubProfileProgress } from '@/shared/api/requests/profile-progress/club/request';

export const useClubProfileProgressQuery = (
  params: ClubProfileProgressRequest,
  settings?: QuerySettings<typeof clubProfileProgress>
) =>
  useQuery({
    queryKey: ['ClubProfileProgress', params.profileId],
    queryFn: () =>
      clubProfileProgress({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
